import React, {useContext, useState} from "react";
import cn from "classnames";
import styles from "./Transfer.module.sass";
import Loader from "../Loader";
import {message} from 'antd';
import {Web3Context} from "../../contexts/Web3Context";
import {getContracts} from "../../adapters/eth";
import {isAddress} from "web3-utils";

message.config({top: 100, duration: 5, maxCount: 3,});

const Transfer = ({className, item, onOutsideClick}) => {

  const [receiver, setReceiver] = useState('');
  const [inProcess, setInProcess] = useState(false);

  const {web3, defaultAccount} = useContext(Web3Context)

  const handleReceiver = (event) => {
    setReceiver(event.target.value);
  };

  const transferIt = async (event) => {
    event.preventDefault();
    setInProcess(true);

    try {
      const contracts = await getContracts(web3);

      if (!isAddress(receiver)) {
        setInProcess(false);
        message.warning('Invalid recipient address');
        return false;
      }

      contracts.Nft.methods.safeTransferFrom(defaultAccount, receiver, item.token_id)
        .send({from: defaultAccount})
        .once('receipt', () => {
          setInProcess(false);
          message.success('Done');
          window.location.reload();
        })
        .on('error', e => {
          console.log(e);
          message.error('Error when transfer token!');
          setInProcess(false);
          return false;
        });
    } catch (e) {
      console.log(e);
      message.error('Error when transfer token!');
      setInProcess(false);
      return false;
    }
  };

  return (
    <div className={cn(className, styles.transfer)}>
      <div className={cn("h4", styles.title)}>Transfer token</div>
      <div className={styles.text}>
        You can transfer tokens from your address to another
      </div>
      <div className={styles.info}>Receiver address</div>
      <div className={styles.field}>
        <input
          className={styles.input}
          type="text"
          name="address"
          placeholder="Paste address"
          value={receiver}
          onChange={handleReceiver}
        />
      </div>
      <div className={styles.btns}>
        <button className={cn("button", styles.button)} onClick={transferIt}>
          {inProcess ?
            <Loader className={styles.loader} color="white"/> :
            'Transfer'
          }
        </button>
        <button className={cn("button-stroke", styles.button)} onClick={onOutsideClick}>Cancel</button>
      </div>
    </div>
  );
};

export default Transfer;
